import { Component } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";
import { AuthService } from "../services/auth.service";
import { User } from "../models/user.model";

@Component({
    selector: 'app-page',
    templateUrl: 'page.component.html',
    styleUrls: ['page.component.scss']
})
export class PageComponent {

    public user: User | null = null;
    public isAdmin = false;
    public readonly adminLinks = [
        {
            label: 'Gestion des utilisateurs',
            route: '/user',
            icon: 'people-outline'
        },
        {
            label: 'Dashboard client',
            route: '/dashboard',
            icon: 'monitor-outline'
        },
        {
            label: 'Moyennes nationales',
            route: '/national-average',
            icon: 'bar-chart-outline'
        },
        {
            label: 'Logs des crons',
            route: '/cron-logs',
            icon: 'clock-outline'
        }
    ];

    constructor(
        protected authService: AuthService,
        protected router: Router
    ) {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((ev: any) => {
            if (ev.url == '/') {
                // Redirection basée sur le rôle
                const user = this.authService.getConnectedUser();
                if (user?.role === 'ADMIN') {
                    this.router.navigateByUrl('/user');
                } else {
                    this.router.navigateByUrl('/dashboard');
                }
            }

            this.refreshUserContext();
        });

        this.refreshUserContext();
    }

    public goToDashboard(): void {
        // Redirection basée sur le rôle
        if (this.isAdmin) {
            this.router.navigateByUrl('/user');
        } else {
            this.router.navigateByUrl('/dashboard');
        }
    }

    public logoutAction(): void {
        this.authService.logout()
            .subscribe({
                next: () => {
                    this.router.navigate(['/auth']);
                },
                error: () => {
                    this.router.navigate(['/auth']);
                }
            });
    }

    public goToAdminRoute(route: string): void {
        this.router.navigateByUrl(route);
    }

    public isLinkActive(route: string): boolean {
        return this.router.url.startsWith(route);
    }

    private refreshUserContext(): void {
        this.user = this.authService.getConnectedUser();
        this.isAdmin = this.user?.role === 'ADMIN';
    }
}
